'use strict';

angular.module('supervisorAccessReviewControllers')

.controller('ProgressBar_SystemToReviewController', ['$scope', '$stateParams', 'systemToReviewService', function ($scope, $stateParams, systemToReviewService) {

    $scope.authLogin = $stateParams.authLogin;

    $scope.updateProgressBar = function () {
        systemToReviewService.getNbRemainingSystemsToReview($scope.authLogin)
                             .then(function (stats) {
                                 $scope.NbRemaining = stats.NbRemaining;
                                 $scope.NbSystems = stats.NbSystems;
                             });
    };
    $scope.updateProgressBar();

    $scope.$on('newReviewSystem', function () {
        $scope.updateProgressBar();
    });
}]);